<app-loading-spinner *ngIf="isLoading" />


<div *ngIf="!isLoading" class="w-full overflow-x-auto">

    <div class="w-full px-10 pb-7 pt-4 bg-tileLight dark:bg-[#363636] rounded-lg ">

        <div class="w-full dark:bg-[#363636]">
            <div class="flex flex-row items-center justify-center">
                <p class="text-lg font-semibold text-[#292929] mx-3 dark:text-white">From :</p>

                <div class="relative w-56 mr-10">
                    <app-custom-datepicker #fromDatePicker [placeholder]="'--Select Date--'" [(selectedDate)]="fromDate"
                        (dateChange)="onFromDateChange($event)">
                    </app-custom-datepicker>
                </div>

                <p class="text-lg font-semibold text-[#292929] mx-3 dark:text-white">To :</p>

                <div class="relative w-56 mr-6">
                    <app-custom-datepicker #toDatePicker [placeholder]="'--Select Date--'" [selectedDate]="toDate"
                        (dateChange)="onToDateChange($event)">
                    </app-custom-datepicker>
                </div>

                <button (click)="goBtn()"
                    class="bg-[#415CFF] text-lg text-white font-semibold px-6 py-2 rounded-lg shadow-lg ml-5 dark:text-white">
                    Go
                </button>
            </div>
        </div>

    </div>

    <hr />

    <div *ngIf="hasData && isDateFilterSet">
        <div class="flex flex-row flex-wrap items-center justify-between gap-4 mt-6">
            <div class="flex flex-row gap-4">
                <div class="flex flex-col justify-between flex-shrink-0">
                    <p class="font-semibold mb-1 text-lg dark:text-white whitespace-nowrap">All
                        ( {{totalItems | number:'2.0-0'}} )</p>
                </div>
            </div>

            <div class="flex flex-row flex-wrap items-center justify-end gap-5 flex-1 min-w-0">
                <i *ngIf="logingRole === 'Collection Centre Head'"
                    class="fa-solid fa-list text-lg text-[#4A4A4A] dark:text-white ml-8"></i>

                <p *ngIf="logingRole === 'Collection Centre Head'"
                    class="font-normal text-[16px] text-[#4A4A4A] dark:text-white">
                    Filter By
                </p>

                <div class="relative w-64 flex-shrink-0 custom-center-dropdown-container"
                    *ngIf="logingRole === 'Collection Centre Head'">

                    <app-searchable-dropdown [items]="centerDropdownItems" placeholder="Select Centre..."
                        searchPlaceholder="Search centre..." [(ngModel)]="selectCenters"
                        (selectionChange)="onCenterSelectionChange($event)" [clearable]="true" [showSelected]="true"
                        [disabled]="false" class="w-full"></app-searchable-dropdown>

                </div>



                <div class="flex items-center rounded-full px-4 py-2 flex-1 min-w-48 max-w-xs bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Crop, Variety Name..." [(ngModel)]="searchText"
                        (keyup.enter)="onSearch()" (input)="checkLeadingSpace()"
                        class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()" (keyup.esc)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

            </div>

        </div>

        <div class="flex justify-end items-center mb-5 mt-3"> <!-- Changed this line -->
            <!-- <div class="text-lg font-medium">
                <p class="font-semibold mb-1 text-lg dark:text-white whitespace-nowrap">
                    <span class="text-gray-500 dark:textDark">Total : </span>Rs {{ totalPaymentsAmount | number:'1.2-2'
                    }}
                </p>
            </div> -->

            <button
                class="bg-[#415CFF] text-white shadow-md font-medium rounded-lg py-2 px-5 text-lg flex items-center"
                (click)="downloadTemplate1()">
                <i class="fa-solid fa-download px-2" *ngIf="!isDownloading"></i>
                <i class="fa-solid fa-spinner fa-spin px-2" *ngIf="isDownloading"></i>
                {{ isDownloading ? " Downloading..." : " Download" }}
            </button>
        </div>

        <div *ngIf="hasData" class="mt-5">
            <div class="isolate overflow-auto max-h-[max(390px,calc(100vh-760px))] border-gray-100 border-[2px] dark:border-[#202021] rounded-lg">
                <table class="w-full min-w-max divide-y-2">
                    <thead class="sticky top-0 z-20 bg-white dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] text-[#4B5563]">
                        <tr>
                            <th class="sticky left-0 bg-white dark:bg-[#0F0F0F] w-14 min-w-14 px-2 py-3 text-base text-center font-medium">No</th>
                            <th class="sticky left-14 bg-white dark:bg-[#0F0F0F] w-36 min-w-36 px-3 py-3 text-left text-base font-medium"
                                *ngIf="logingRole === 'Collection Centre Head'">Centre Code</th>
                            <th class="px-3 py-3 text-left text-base font-medium"
                                *ngIf="logingRole === 'Collection Centre Head'">Centre Name</th>
                            <th class="w-36 min-w-36 px-3 py-3 text-left text-base font-medium"
                                [ngClass]="{'sticky left-14 bg-white dark:bg-[#0F0F0F]': logingRole !== 'Collection Centre Head'}">Crop</th>
                            <th class="px-1 py-3 text-left text-base font-medium w-52">Variety</th>
                            <th class="px-3 py-3 text-center text-base font-medium ">Quantity A (kg)</th>
                            <th class="px-3 py-3 text-center text-base font-medium">Quantity B (kg)</th>
                            <th class="px-3 py-3 text-center text-base font-medium">Quantity C (kg)</th>
                            <th class="px-3 py-3 text-center text-base font-medium">Total (kg)</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white text-[#000000] font-semibold dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                        <tr *ngFor="let item of farmerPaymentsArr | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  };  let i = index">
                            <td class="sticky left-0 z-10 bg-white dark:bg-[#1D1D1F] px-2 py-4 text-center text-base text-gray-900 dark:text-gray-300">
                                {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) + i +
                                    1) : (((page - 1) * itemsPerPage) + i + 1) }} </td>
                            <td class="sticky left-14 z-10 bg-white dark:bg-[#1D1D1F] px-3 py-4 text-base text-gray-900 dark:text-gray-300 break-all"
                                *ngIf="logingRole === 'Collection Centre Head'">{{item.centerCode}}</td>
                            <td class="px-3 py-4 text-base text-gray-900 dark:text-gray-300"
                                *ngIf="logingRole === 'Collection Centre Head'">{{item.centerName}}</td>
                            <td class="px-3 py-4 text-base text-gray-900 dark:text-gray-300"
                                [ngClass]="{'sticky left-14 z-10 bg-white dark:bg-[#1D1D1F]': logingRole !== 'Collection Centre Head'}">
                                {{ item.cropNameEnglish || '-' }}
                            </td>
                            <td class="px-1 py-4 w-52 text-base text-left text-gray-900 dark:text-gray-300">
                                {{ item.varietyNameEnglish || '-' }}
                            </td>
                            <td class="px-3 py-4 text-base text-center dark:text-gray-300">{{item.totalGradeAQuantity |
                                number:
                                '1.2-2' }}</td>
                            <td class="px-3 py-4 text-base text-center dark:text-gray-300">{{item.totalGradeBQuantity |
                                number:
                                '1.2-2' }}</td>
                            <td class="px-3 py-4 text-base text-center dark:text-gray-300">{{item.totalGradeCQuantity |
                                number:
                                '1.2-2' }}</td>
                            <td class="px-3 py-4 text-base text-center dark:text-gray-300">
                                {{ item.totalQuantity | number: '1.2-2' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex justify-end items-center my-5 pt-3 dark:bg-[#1D1D1F] text-right">
                <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true"
                    [previousLabel]="'Previous'" [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'"
                    [screenReaderPageLabel]="'page'" [screenReaderCurrentLabel]="'Youre on page'">
                </pagination-controls>
            </div>
        </div>
    </div>

    <!-- <div *ngIf="!isDateFilterSet" class="flex justify-center items-center mt-8 mr-5 h-[500px] dark:bg-[#292929] ">
        <p class="text-3xl text-center font-semibold dark:text-white">--Set From & To Dates first--</p>
    </div> -->

    <div *ngIf="!isDateFilterSet" class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
        <p class="text-[#494949] my-6 dark:text-textDark">--Set From & To Dates first--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>

    <div *ngIf="!hasData && isDateFilterSet" class="h-[500px]">
        <div class="flex flex-row flex-wrap items-center justify-between gap-4 mt-6">
            <div class="flex flex-row gap-4">
                <div class="flex flex-col justify-between flex-shrink-0">
                    <p class="font-semibold mb-1 text-lg dark:text-white whitespace-nowrap">All
                        ( {{totalItems | number:'2.0-0'}} )</p>
                </div>
            </div>

            <div class="flex flex-row flex-wrap items-center justify-end gap-5 flex-1 min-w-0">
                <i *ngIf="logingRole === 'Collection Centre Head'"
                    class="fa-solid fa-list text-[#4A4A4A] text-lg dark:text-white ml-8"></i>

                <p *ngIf="logingRole === 'Collection Centre Head'" class="font-normal dark:text-white">Filter By</p>


                <div class="relative w-64 flex-shrink-0 custom-center-dropdown-container"
                    *ngIf="logingRole === 'Collection Centre Head'">
                    <app-searchable-dropdown [items]="centerDropdownItems" placeholder="Select Centre..."
                        searchPlaceholder="Search centre..." [(ngModel)]="selectCenters"
                        (selectionChange)="onCenterSelectionChange($event)" [clearable]="true" [showSelected]="true"
                        [disabled]="false" class="w-full"></app-searchable-dropdown>
                </div>



                <div class="flex items-center rounded-full px-4 py-2 flex-1 min-w-48 max-w-xs bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Crop & Variety Name..." [(ngModel)]="searchText"
                        (keyup.enter)="onSearch()" (keyup.esc)="offSearch()" (input)="checkLeadingSpace()"
                        class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

            </div>

        </div>

        <div class="flex flex-col items-center w-fullpx-10 py-7 mt-6 ">
            <p class="text-[#494949] my-6 dark:text-textDark">--No Data Available--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
        </div>
    </div>
</div>
